// CONSTANTS ACROSS THE APP
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SECONDS = 10;
export const RES_PER_PAGE = 10;
export const KEY = '87924ede-e516-4385-a8c7-da9f02f5c269';
export const MODAL_CLOSE_SEC = 2.5;
